// extracted by mini-css-extract-plugin
export var wrapper = "DownloadList-module--wrapper--6lyZe";